import { Injectable } from '@angular/core';
import { GridConfigItem } from '@ddv/models';

const absSuffix = '__abs';

@Injectable()
export class ColumnTransformService {
    // Gets the field name for the destination of abs val data, assumes the column is abs val
    getAbsValFieldName(config: GridConfigItem): string {
        return config.value + absSuffix;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    transformAbsoluteValue(gridData: any[], columnConfigs: GridConfigItem[]): void {
        columnConfigs.forEach((config) => {
            if (config.useAbsVal) {
                gridData.forEach((dataRow) => {
                    const absField = this.getAbsValFieldName(config);
                    dataRow[absField] = Math.abs(dataRow[config.value]);
                });
            }
        });
    }
}
